import printing from "../../assets/hero/3d.png";
import loc from "../../assets/loc.png";
import laserImg from "../../assets/hero/laser2.jpg";
import pcbImg from "../../assets/service/pcb.png";
import pdImg from "../../assets/service/pd.png";
import siliconImg from "../../assets/service/silicon2.png";
import sample1 from "../../assets/service/1.png";
import sample2 from "../../assets/service/2.png";
import sample3 from "../../assets/service/3.png";
import sample4 from "../../assets/service/4.png";
import sample5 from "../../assets/service/5.png";

const data = [
  {
    slug: "3D-Printing",
    data: {
      title: "3D Printing Service",
      subtitle:
        "We provide quality 3D printed parts with a wide variety of materials available in the quickest possible time.",
      img: printing,
      list: ["FDM 3D Printing", "SLA 3D Printing"],
      content: [
        {
          title: "FDM 3D Printing",
          description:
            "Fused Deposition Modeling. FDM 3D printing is the most used, available and affordable 3D printing technology. It has a resolution of 0.1mm-1mm layer height which is very suitable for rapid and low cost prototyping. FDM printing parts, especially PLA, tend to elongate rather than break. Specification of our FDM printing is given below",
          categories: [
            {
              name: "Service Details",
              content: [
                "Layer Height: 0.1mm -0.8mm",
                "Material: PLA, ABS, PETG",
                "Print volume: 256mm x 256mm x 256mm (max), 230mm x 230mm x 300mm(regular)",
                "Color: single color. Two color is also possible",
                "Temperature sensitivity: Not suitable for uses in temperatures of over 100 degree celsius. ",
                "Surface finish: A bit rough compared to SLA printing. Greater surface finish can be achieved through our post processing service. ",
                "Filetype: .stl, .obj, .3mf, .step, .stp, .igs.",
              ],
            },
            {
              name: "Use Cases",
              content: [
                "Low budget and rapid prototyping",
                "Mechanical Parts",
                "Functional models",
                "Cosplay props",
                "Trial and error",
                "Low quantity mass production",
              ],
            },
            {
              name: "Pricing",
              content: [
                <span>
                  <b>PLA</b>: 6-10tk per gram
                </span>,
                <span>
                  <b>ABS</b>: 8-12tk per gram
                </span>,
                <span>
                  <b>PETG</b>: 8-12tk per gram
                </span>,
              ],
              subcontent: (
                <>
                  <img src={loc} style={{ height: 18 }} alt="Location" />{" "}
                  <b>Post processing: depends on model and quantity</b>
                </>
              ),
              notice:
                "**Pricing may vary depending on model type, material, quantity etc. ",
            },
            {
              name: "Design Standards",
              content: [
                "Please separate multiple bodies in individual files.",
                "Clearance fit allowance (0.4mm nozzle):	>0.4mm",
                "Transition fit allowance (0.4mm nozzle):	0.2mm - 0.4mm",
                "Interference fit allowance (0.4mm nozzle): 0.1mm",
                "Dimensional Accuracy: +-0.2mm",
              ],
            },
            {
              name: "Samples",
              images: [sample1, sample2, sample3, sample4, sample5],
            },
          ],
        },
        {
          title: "FDM 3D Printing",
          description:
            "Stereolithography is best used for printing organic shapes and higher resolution models. The hardness of the material is more than FDM printing materials. The material tends to maintain its physical property under stress. Temperature sustainability is more than PLA or ABS. Though it is more costly compared to FDM printing, the quality of the finish is worth it!. The specs are given below:",
          categories: [
            {
              name: "Service Details",
              content: [
                "Layer Height: 0.05mm",
                "Material: UV resin based plastic (Hard, flexible both option can be printed)",
                'Print volume: 	5.11" x 3.14" x 6.49" (130mm x 80mm x 165mm) Regular( 4k and 2K)',
                '7.55" x 4.72" x 9.84" (192mm x 120mm x 245mm) Max',
                "Color: Mono color",
                "Surface finish: 	Very fine, no layer line will be visible ",
                "Filetype: .stl, .obj, .3mf, .step, .stp, .igs.",
              ],
            },
            {
              name: "Use Cases",
              content: [
                "Smooth organic models",
                "Mechanical parts",
                "Product enclosure prototyping",
                "Action figure",
                "Scale models",
                "Cosplay Props",
                "Mold for silicone molding ",
                "Medical plastic figures",
              ],
            },
            {
              name: "Pricing",
              content: [
                <span>
                  <b>15tk -20tk per gram (depends on model and quantity)</b>
                </span>,
              ],
              notice:
                "**Pricing may vary depending on model type, material, quantity etc. ",
            },
          ],
        },
      ],
    },
  },
  {
    slug: "Laser-Cutting",
    data: {
      title: "Laser Cutting",
      subtitle:
        "Need laser cutting for your project or prototype? Request online quote today!",
      img: laserImg,
      content: [
        {
          title: "Laser Cutting",
          description:
            "Our high power CO2 laser cutter machine can cut or engrave on any plastic, paper, wooden or organic material like leather, clothes etc easily upto 8mm thickness (depends on material). Laser cutting is very suitable for low cost mass production and even for low cost prototyping. Note that we don’t work with sheet metal yet. ",
          categories: [
            {
              name: "Service Details",
              content: [
                <span>
                  <b>Maximum cutting size:</b> 35” x 50”{" "}
                </span>,
                <span>
                  <b>Material type:</b> Plywood (upto 6mm)
                </span>,
                <span>
                  <b>PVC</b> (upto 8mm)
                </span>,
                <span>
                  <b>Acrylic</b> (Upto 8mm)
                </span>,
                <span>
                  <b>Wood</b> (kerosin, balsa, maple, oak etc)
                </span>,
                <span>
                  <b>Leather</b>
                </span>,
                <span>
                  <b>Jeans</b> etc
                </span>,
                <span>
                  <b>Cutting tolerance:</b> 0.5mm
                </span>,
                <span>
                  <b>Machine accuracy:</b> 0.2mm
                </span>,
                <span>
                  <b>Filetype:</b> .dxf, .pdf, .ai
                </span>,
              ],
            },
            {
              name: "Pricing",
              content: [
                <span>3000 bdt per hour (Wooden or plastic over 3mm)</span>,
                <span>2500 bdt per hour (Wooden or acrylic 3mm)</span>,
                <span>2000 bdt per hour (PVC upto 1mm-3mm)</span>,
                <span>
                  1500 bdt per hour (Thin material like paper, cloths etc)
                </span>,
                <span className="text_danger">
                  **Material price will be calculated as per our purchasing
                  price
                </span>,
              ],
              subcontent:
                ((
                  <span>
                    <b>Pricing scheme:</b> All pricing is based on the following
                    criterias:
                    <br />
                    Cutting speed: 30mm/s
                    <br />
                    Engraving (hatching) speed: 150mm/s
                    <br />
                  </span>
                ),
                (
                  <span className="text_danger">
                    **Pricing may vary depending on the quantity, material type
                    and job type.
                  </span>
                )),
            },
            {
              name: "Design Standards",
              content: [
                `Color code:	Black = Line Cut`,
                `Red   = Line Hatch (Engrave)`,
                `Blue  =  Scanning engrave `,
                `Minimum gap between two cutting lines: 1mm`,
                `Maximum taper angle: 	5 degree`,
                `Average kerf width: 	0.25mm`,
              ],
            },
          ],
        },
      ],
    },
  },
  {
    slug: "PCB-Manufacturing",
    data: {
      title: "PCB Manufacturing",
      subtitle:
        "We manufacture good quality single and double layer PCB. Request an online quote now!",
      img: pcbImg,
      content: [
        {
          title: "PCB Manufacturing",
          description:
            "We manufacture quality Printed Circuit Boards in both mass quantity and low quantity. Our PCB specification if given below:",
          categories: [
            {
              name: "Design Rule Standards",
              content: [
                `Layer: 	Single and double layer`,
                `Through Hole Plating:  No`,
                `Maximum size: A4 (210mm x 297mm)`,
                `Board material: FR4 ZD fiber, ZD red, and glass fiber`,
                `Copper thickness: 1oz`,
                `Minimum trace width: 	15mill (0.381mm)`,
                `Min trace to trace gap: 15mill (0.381mm)`,
                `Min drill diameter: 	0.5mm`,
                `Outline cutting: 	Supports splines (Gerber needed)`,
                `Drill alignment tolerance: +-0.2mm`,
                `Board finish: 		HASL, Rosin based`,
                `Masking type: 		Heat proof, normal`,
                `Top/bottom silk: 	Heat proof, normal`,
              ],
            },
            {
              name: "File Type",
              content: [
                <span>
                  <b>
                    PDF (for no spline outline support and accurate drilling)
                  </b>
                </span>,
                <span>
                  <b>Gerber (For accurate output)</b>
                </span>,
              ],
            },
            {
              name: "Pricing",
              header: "Pricing depends on following criterias:",
              content: [
                `5tk per square inch (single layer etch + drill)`,
                `8tk per square inch (double layer etch + drill)`,
                `1tk per square inch (masking per layer)`,
                `1tk per square inch (silk screen per layer)`,
                `Processing cost: depends on the PCB `,
              ],
              notice:
                "Pricing may vary depending on PCB quantity and specification. All pricing based on a maximum drill count of 10 per square inch. ",
            },
          ],
        },
      ],
    },
  },

  {
    slug: "Product-Development",
    data: {
      title: "Product Development",
      subtitle:
        "Get quality Products and production parts. Request an online quote today.",
      img: pdImg,
      content: [
        {
          title: "Product Development",
          description:
            "We manufacture quality Printed Circuit Boards in both mass quantity and low quantity. Our PCB specification if given below:",
          categories: [
            {
              name: "Service Details",
              content: [
                `We provide product development and RnD support with prototyping and mass production. We have a team of well skilled engineers for RnD in mechanical, electronics and software programming sections. Please contact our helpline or pay us a visit for more detailed information about our product development service, pricing and others`,
              ],
            },
          ],
        },
      ],
    },
  },
  {
    slug: "Silicon-Molding",
    data: {
      title: "Silicone Molding",
      subtitle:
        "Get quality Products and production parts. Request an online quote today.",
      img: siliconImg,
      content: [
        {
          title: "Silicone Molding",
          description:
            "Get quality Products and production parts. Request an online quote today.",
          categories: [
            {
              name: "No Content",
              content: [],
            },
          ],
        },
      ],
    },
  },
];

export default data;
